<!-- DEPRECATED in favour of ModalV2 -->
<template>
  <div
    class="flex h-full max-h-full w-full max-w-full items-center justify-center"
    data-testid="dialog"
  >
    <div
      class="flex flex-col overflow-hidden bg-white"
      :class="[
        dialogSizeClassMap[size],
        hideTitle ? '' : 'rounded-md px-3 py-4',
      ]"
    >
      <div class="flex h-full gap-3 overflow-hidden">
        <div v-if="type === 'danger'">
          <div class="bg-danger-100 rounded-full p-3">
            <TIcon size="32" class="text-danger" name="warning" />
          </div>
        </div>
        <div class="flex flex-1 flex-col overflow-hidden">
          <div
            v-if="!hideTitle"
            class="relative flex items-center justify-between text-2xl font-bold"
          >
            <div class="grow overflow-hidden">
              <slot name="title"><div></div></slot>
            </div>
            <div v-if="closeable" class="z-100">
              <TButton
                type="tonal"
                color="neutral"
                icon="close"
                @click="modal.close()"
              />
            </div>
          </div>

          <!-- close icon increases the visual height of the title, compensating this with a smaller mt than mb -->
          <div
            class="flex flex-1 overflow-hidden"
            :class="{
              'mt-2 mb-3': !hideTitle,
            }"
          >
            <div class="flex-1 overflow-auto px-1">
              <slot name="content" :close="() => modal.close()"></slot>
            </div>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end gap-3 px-1">
        <slot name="actions" :close="() => modal.close()"></slot>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { injectOrFail } from '@teachino/shared-util';
import { onBeforeUnmount, onMounted } from 'vue';
import TButton from './Button/TButton.vue';
import TIcon from './Icon/TIcon.vue';
import { modalKey } from './Modal/modal-key';

const emit = defineEmits<{ closed: [] }>();

const modal = injectOrFail(modalKey);
modal.onClose(() => {
  emit('closed');
});
type DialogSize = 'small' | 'fit' | 'large' | 'full' | 'medium';

const dialogSizeClassMap: Record<DialogSize, string> = {
  small: 'w-full max-w-xl h-fit max-h-[90%]',
  fit: 'w-fit h-fit max-h-full',
  large: 'w-full md:min-w-xl max-w-4xl max-h-[87%]',
  full: 'h-full w-full',
  medium: 'h-full md:max-h-[80%] max-w-2xl w-full',
};

const props = withDefaults(
  defineProps<{
    type?: 'neutral' | 'danger';
    closeable?: boolean;
    hideTitle?: boolean;
    size?: DialogSize;
  }>(),
  {
    type: 'neutral',
    closeable: true,
    hideTitle: false,
    size: 'fit',
  },
);

function closeEventCb(e: KeyboardEvent): void {
  if (e.key === 'Escape' && props.closeable) {
    modal.close();
  }
}
onMounted(() => {
  document.documentElement.addEventListener('keydown', closeEventCb);
});
onBeforeUnmount(() => {
  document.documentElement.removeEventListener('keydown', closeEventCb);
});
</script>
